"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalInboxCountQuerySchema = exports.approvalInboxQuerySchema = exports.APPROVAL_INBOX_MAX_PAGE_SIZE = exports.APPROVAL_INBOX_DEFAULT_PAGE_SIZE = exports.approvalInboxCountResponseSchema = exports.approvalInboxListResponseSchema = exports.approvalInboxCountsByStatusSchema = exports.approvalInboxRowSchema = exports.approvalInboxEntityTypeSchema = exports.APPROVAL_INBOX_ENTITY_TYPES = exports.approvalInboxActionSchema = exports.approvalInboxActionTypeSchema = exports.APPROVAL_INBOX_ACTION_TYPES = exports.approvalInboxStatusSchema = exports.APPROVAL_INBOX_STATUSES = exports.approvalInboxPaymentScopeSchema = exports.APPROVAL_INBOX_PAYMENT_SCOPES = exports.approvalInboxScopeSchema = exports.APPROVAL_INBOX_SCOPES = void 0;
const zod_1 = require("zod");
const approval_rules_1 = require("./approval-rules");
exports.APPROVAL_INBOX_SCOPES = ['act', 'submitted', 'acted', 'all'];
exports.approvalInboxScopeSchema = zod_1.z.enum(exports.APPROVAL_INBOX_SCOPES);
// Splits the inbox by the invoice (payment) entity: the main Approvals inbox
// runs 'exclude'; the dedicated Payment Approvals page runs 'only'.
exports.APPROVAL_INBOX_PAYMENT_SCOPES = ['all', 'only', 'exclude'];
exports.approvalInboxPaymentScopeSchema = zod_1.z.enum(exports.APPROVAL_INBOX_PAYMENT_SCOPES);
exports.APPROVAL_INBOX_STATUSES = [
    'pending',
    'changes_requested',
    'approved',
    'rejected',
];
exports.approvalInboxStatusSchema = zod_1.z.enum(exports.APPROVAL_INBOX_STATUSES);
exports.APPROVAL_INBOX_ACTION_TYPES = ['Approve', 'Reject', 'Request Changes'];
exports.approvalInboxActionTypeSchema = zod_1.z.enum(exports.APPROVAL_INBOX_ACTION_TYPES);
exports.approvalInboxActionSchema = zod_1.z.object({
    role: approval_rules_1.pgApproverRoleSchema,
    action_type: exports.approvalInboxActionTypeSchema,
    comment: zod_1.z.string().nullable(),
    taken_at: zod_1.z.string(),
    actor_name: zod_1.z.string().nullable(),
    cycle: zod_1.z.number().int().min(1),
});
exports.APPROVAL_INBOX_ENTITY_TYPES = [
    'ticket',
    'hedge_request',
    'inventory_match',
    'document',
    'invoice',
];
exports.approvalInboxEntityTypeSchema = zod_1.z.enum(exports.APPROVAL_INBOX_ENTITY_TYPES);
exports.approvalInboxRowSchema = zod_1.z.object({
    workflow_id: zod_1.z.string().uuid(),
    entity_type: approval_rules_1.approvalEntityTypeSchema,
    entity_id: zod_1.z.string(),
    entity_label: zod_1.z.string(),
    entity_link: zod_1.z.string().nullable(),
    reason: zod_1.z.string().nullable(),
    rule_id: zod_1.z.string().uuid().nullable(),
    rule_label: zod_1.z.string(),
    approval_status: exports.approvalInboxStatusSchema,
    approval_mode: approval_rules_1.approvalModeSchema,
    required_approvers: zod_1.z.array(approval_rules_1.pgApproverRoleSchema),
    actions: zod_1.z.array(exports.approvalInboxActionSchema),
    current_approver_index: zod_1.z.number().int(),
    cycle: zod_1.z.number().int(),
    submitted_at: zod_1.z.string(),
    submitter_name: zod_1.z.string().nullable(),
    submitter_user_id: zod_1.z.string().uuid().nullable(),
});
exports.approvalInboxCountsByStatusSchema = zod_1.z.object({
    pending: zod_1.z.number().int().min(0),
    changes_requested: zod_1.z.number().int().min(0),
    approved: zod_1.z.number().int().min(0),
    rejected: zod_1.z.number().int().min(0),
});
exports.approvalInboxListResponseSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.approvalInboxRowSchema),
    total: zod_1.z.number().int().min(0),
    counts_by_status: exports.approvalInboxCountsByStatusSchema,
    page: zod_1.z.number().int().min(1),
    page_size: zod_1.z.number().int().min(1),
});
exports.approvalInboxCountResponseSchema = zod_1.z.object({
    count: zod_1.z.number().int().min(0),
    has_approver_roles: zod_1.z.boolean(),
});
function csvList(inner) {
    return zod_1.z.preprocess((value) => {
        if (value === undefined || value === null || value === '')
            return undefined;
        if (Array.isArray(value))
            return value;
        if (typeof value === 'string') {
            return value
                .split(',')
                .map((s) => s.trim())
                .filter((s) => s.length > 0);
        }
        return value;
    }, zod_1.z.array(inner).optional());
}
const boolFlag = zod_1.z.preprocess((value) => {
    if (value === undefined || value === null || value === '')
        return undefined;
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'string')
        return value === 'true' || value === '1';
    return value;
}, zod_1.z.boolean().optional());
exports.APPROVAL_INBOX_DEFAULT_PAGE_SIZE = 50;
// Must track INBOX_CANDIDATE_CAP in the backend inbox service.
exports.APPROVAL_INBOX_MAX_PAGE_SIZE = 500;
exports.approvalInboxQuerySchema = zod_1.z
    .object({
    scope: exports.approvalInboxScopeSchema.default('act'),
    payment_scope: exports.approvalInboxPaymentScopeSchema.default('all'),
    entity_types: csvList(exports.approvalInboxEntityTypeSchema),
    rule_ids: csvList(zod_1.z.string().uuid()),
    statuses: csvList(exports.approvalInboxStatusSchema),
    include_resolved: boolFlag,
    include_soft_deleted: boolFlag,
    page: zod_1.z.coerce.number().int().min(1).default(1),
    page_size: zod_1.z.coerce
        .number()
        .int()
        .min(1)
        .max(exports.APPROVAL_INBOX_MAX_PAGE_SIZE)
        .default(exports.APPROVAL_INBOX_DEFAULT_PAGE_SIZE),
})
    .strict();
exports.approvalInboxCountQuerySchema = zod_1.z
    .object({
    payment_scope: exports.approvalInboxPaymentScopeSchema.default('all'),
})
    .strict();
//# sourceMappingURL=approval-inbox.js.map